import Vue from "vue";
import pages from "./pages";
import zebralist from "./zebralist";

const mixins = [pages, zebralist];
mixins.forEach((mixin) => Vue.mixin(mixin));
